import React, { Fragment } from 'react';
import { isDesktop } from "react-device-detect";

//hooks
import { UseData } from '../../hooks/UseData';

//ads
import LateralIzquierdo from '../../ads/LateralIzquierdo';
import LateralDerecho from '../../ads/LateralDerecho';
import Caja3 from '../../ads/Caja3';
import Zocalo from '../../ads/Zocalo';

//components
import Loading from '../common/Loading';
import Categories from './Categories';
import Footer from '../common/Footer';

const Home = () => {

    const [loading, data] = UseData();    
    
    return (
        <Fragment>
            <main className="container d-flex justify-content-around px-0">
                {isDesktop && <LateralIzquierdo />}
                <section className="container cont-layout px-0 px-md-2">
                {
                    loading 
                    ? <Loading />
                    : <Categories data={data} />        
                }              
                </section>
                {isDesktop && <LateralDerecho />}                
            </main>
            <section className="content-msgs">
                {!isDesktop && <Caja3 />}        
                <Zocalo isDesktop={isDesktop} />
            </section>         
            <Footer />   
        </Fragment>
    )
}

export default Home;